import type { CmsScreen } from '../cmsScreenRegistry';

/**
 * Placeholder for a CMS Admin screen whose registry `status` is `'pending'`.
 *
 * Phase 7 run 1 built the SHELL with all 31 feature modules `pending`, so the
 * shell could be navigated and verified end-to-end while `/admin/` was still
 * served by Backbone. Every screen has since been ported (the registry has no
 * `pending` entries; `/admin/` is live React since the T10 switch), so normal
 * navigation never reaches this — it remains only as the fallback
 * `CmsScreenHost` renders for a registry entry without a `load`.
 *
 * Deliberately plain: it must never be mistaken for a finished screen.
 */
const CmsPendingScreen = ({ screen }: { screen?: CmsScreen }) => {
  if (!screen) return null;
  return (
    <div className="cms-pending-screen" data-cms-pending={screen.key}>
      <h1 className="cms-heading__title">{screen.key}</h1>
      <p>
        Not yet migrated — legacy module <code>cms/mvc/{screen.module}</code>, tranche{' '}
        <strong>{screen.tranche}</strong>.
      </p>
      <p>
        See <code>frontend/PHASE7_CMS_SURVEY.md</code> §5 for the sequencing plan. To land this
        screen, add its component and flip <code>status</code> to <code>&apos;live&apos;</code> in{' '}
        <code>cmsScreenRegistry.ts</code>.
      </p>
    </div>
  );
};

export default CmsPendingScreen;
